import { apiClient } from 'pobble-components/dist/api'

const apiCreatePASession = (data, params) =>
  apiClient.post('/v3/pa_sessions', data, { params })

export { apiCreatePASession }
